export default __webpack_public_path__ + "static/media/helping_our_own.5517e45d.png";